import moment from 'moment';

export const isDict = obj => typeof obj === 'object' && obj !== null && !(obj instanceof Array) && !(obj instanceof Date);

export const isArray = obj => obj instanceof Array;

export const removeAccent = (input) => {
  if (!input) return input;

  let str = input.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');

  return str;
};

export const isEmptyObj = (obj) => {
  if (!obj) return true;
  return !Object.keys(obj).some(key => !!obj[key]);
};

export const splitArray = (array, cond) => {
  const match = [];
  const notMatch = [];
  array.forEach((item) => {
    if (cond(item)) {
      match.push(item);
    } else {
      notMatch.push(item);
    }
  });
  return { match, notMatch };
};

export const orderArray = (array, cond) => {
  const { match, notMatch } = splitArray(array, cond);
  return [...match, ...notMatch];
};

export const addToArray = (array, cond, ...newItem) => {
  let index = array.findIndex(cond);
  if (index === -1) index = array.length; // add to end of array
  array.splice(index, 0, ...newItem);
  return array;
};


export const arrayToDict = (array, key = 'id') => {
  if (!array) return {};
  const result = {};
  array.forEach((item) => {
    result[item[key]] = item;
  });
  return result;
};

export const findDuplicate = (items) => {
  const sorted = items.slice().sort();
  const results = [];
  for (let i = 0; i < sorted.length - 1; i += 1) {
    if (sorted[i + 1] === sorted[i]) {
      results.push(sorted[i]);
    }
  }

  return results;
};

export const getAttr = (obj, attr) => {
  if (!obj) return null;
  if (typeof (attr) === 'function') return attr(obj);

  const i = attr.indexOf('.');
  if (i === -1) return obj[attr];

  const firstAttr = attr.substr(0, i);
  const lastAttr = attr.substr(i + 1);
  return getAttr(obj[firstAttr], lastAttr);
};

export const sumTotal = (array, attrs) => {
  const total = {};
  if (!array || array.length === 0) return total;

  array.forEach((item) => {
    attrs.forEach((attr) => {
      if (total[attr] === undefined) total[attr] = 0;
      total[attr] += (getAttr(item, attr) || 0);
    });
  });

  return total;
};

export const getCurrentQuarter = () => {
  const now = new Date();
  const quarter = Math.ceil((now.getMonth() + 1) / 3);
  const beginQuarter = moment([now.getFullYear(), quarter * 3 - 3, 1]);

  return {
    from: beginQuarter,
    to: moment(beginQuarter).add(3, 'months').add(-1, 'days'),
  };
};

export const getReportQuarter = () => {
  const now = new Date();

  const quarter = Math.ceil(now.getMonth() / 3) || 1;
  const beginQuarter = moment([now.getFullYear(), quarter * 3 - 3, 1]);

  return {
    from: beginQuarter,
    to: moment(beginQuarter).add(3, 'months').add(-1, 'days'),
  };
};

export const hasRole = (roles, matchAny, matchAll) => {
  if (typeof (roles) === 'string') {
    roles = roles.split(',');
  }

  if (matchAny) {
    if (typeof (matchAny) === 'string') {
      matchAny = matchAny.split(',');
    }
    return !!roles.find(r => matchAny.indexOf(r) !== -1);
  }

  if (matchAll) {
    if (typeof (matchAll) === 'string') {
      matchAll = matchAll.split(',');
    }
    return !matchAll.find(r => roles.indexOf(r) === -1);
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/utils/misc.js